import React, { MutableRefObject, useCallback, useEffect, useState } from "react"
import { Box, ButtonBase, Typography } from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu";
import * as Cesium from "cesium";
import useCommonDataStore from "../../stores/common2.store";
import useViewStore from "../../stores/viewer2.store";
import { timelineModeVm, TItem } from "../../data/expo/models/timeline-mode.data";
import { SUNGSU_TILESET_ADJUST_HEIGHT } from "../../constants";


const hamburgerIconStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
  marginTop: "15px",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "7px 19px 30px 19px",
  marginLeft: "5px",
  borderRadius: "50%",
};

const TimelineBar = () => (
  <Box
    sx={{
      width: '100%',
      height: '17px',
      background: 'linear-gradient(to right, black, white)',
      borderTop: '3px solid white',
      borderBottom: '3px solid #8B8B8B',
      position: 'relative',
      marginTop: '-13px',
      zIndex: '10'
    }}
  />
);

const YellowCircle = () => (
  <Box
    component="span" 
    sx={{
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      backgroundColor: 'yellow',
      border: '2px solid black',
      display: 'inline-block',
      marginLeft: '10px',
      verticalAlign: 'middle',
    }}
  />
);

const WhiteCircle = () => (
  <Box
    component="span" 
    sx={{
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      backgroundColor: 'white',
      border: '2px solid black',
      display: 'inline-block',
      marginLeft: '10px',
      verticalAlign: 'middle',
    }}
  />
);

const timelineFontStyle = {
  textAlign: 'center',
  fontFamily: "Arimo",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "22px",
  letterSpacing: "-0.43px",
  color: "#FFFFFF",
  zIndex:'800',
  marginTop:'-8px',
  flex: '1',
  cursor: 'pointer',
}

const timelineFontStyle2 = {
  textAlign: 'center',
  fontFamily: "Arimo",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "22px",
  letterSpacing: "-0.43px",
  color: "#FFFFFF",
  zIndex:'800',
  marginTop:'-13px',
  flex: '1',
  cursor: 'pointer',
}

const Timeline = ({ sliderRef }: { sliderRef: MutableRefObject<null> }) => {
  const { commonData, setCommonData } = useCommonDataStore();
  const { setTilsets } = useViewStore();
  const { viewer, setPhase } = useViewStore();
  const [selectedItem, setSelectedItem] = React.useState<TItem | null>(null);
  const [moveActive, setMoveActive] = React.useState(false);

  const [handler, setHandler] = useState<Cesium.ScreenSpaceEventHandler | null>(null);

  const onClickEvent = (name: string) => {
    setCommonData({ ...commonData, slider: true });
    timelineModeVm.items.forEach((item) => {
      if (item.name === name) {
        setSelectedItem(item);
      }
    });
  };


  useEffect(() => {
    if (commonData.isActive !== "Timeline mode" && commonData.slider) {
      setCommonData({ ...commonData, slider: false });
      
      if( sliderRef.current) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const currentRef = sliderRef.current as any;
        currentRef.style.left = '50%';
        setTilsets([]);
        setSelectedItem(null);
      }
    }else if(commonData.isActive === "Timeline mode"){
      setTilsets([]);
      setSelectedItem(null);

      // if(commonData.project==="Bucheon Factory134"){
      //     onClickEvent("22철거");
      //     console.log('Bucheon Factory134');
      //   }
      // else if(commonData.project==="Paju Saemal Village")
      //   {
      //     onClickEvent("철거");
      //   }
      
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commonData.isActive]);


  useEffect(() => {
    if (viewer) {
      viewer.camera.moveEnd.addEventListener(() => {
        if (viewer && sliderRef.current) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const currentRef = sliderRef.current as any;
          viewer.scene.splitPosition =
            currentRef.offsetLeft / currentRef.parentElement.offsetWidth;
        }
      });
    }
  }, [viewer, sliderRef]);


  useEffect(() => {
    if (sliderRef.current && !handler) {
      const tmp = new Cesium.ScreenSpaceEventHandler(
        sliderRef.current as HTMLCanvasElement,
      );
      setHandler(tmp);
    }
  }, [handler, sliderRef]);


  const move = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (movement: any) => {
      if (!moveActive) return;
      if (!viewer) return;

      const relativeOffset = movement.endPosition.x;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const slider = sliderRef.current as any;
      const splitPosition =
        (slider.offsetLeft + relativeOffset) / slider.parentElement.offsetWidth;
      slider.style.left = `${100.0 * splitPosition}%`;
      viewer.scene.splitPosition = splitPosition;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [moveActive, viewer],
  );


  useEffect(() => {
    if (handler) {
      handler.setInputAction(() => {
        setMoveActive(true);
      }, Cesium.ScreenSpaceEventType.LEFT_DOWN);
      handler.setInputAction(() => {
        setMoveActive(false);
      }, Cesium.ScreenSpaceEventType.LEFT_UP);

      handler.setInputAction(move, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      handler.setInputAction(move, Cesium.ScreenSpaceEventType.PINCH_MOVE);

      handler.setInputAction(() => {
        setMoveActive(true);
      }, Cesium.ScreenSpaceEventType.PINCH_START);
      handler.setInputAction(() => {
        setMoveActive(false);
      }, Cesium.ScreenSpaceEventType.PINCH_END);
    }
  }, [handler, move]);

 

  useEffect(() => {
    if (selectedItem) {
      setMoveActive(false);

  
      let h = 0;
      if (selectedItem.name === "남서울 아파트") {
        h = 15;
      } else if (selectedItem.name === "22철거") {
        h = -60;
      } else {
        h = SUNGSU_TILESET_ADJUST_HEIGHT;}

      setTilsets([
        {
          path: selectedItem.modelBeforePath,
          adjustHeight: h,
          splitDirection: Cesium.SplitDirection.LEFT,
        },
        {
          path: selectedItem.modelAfterPath,
          adjustHeight: selectedItem.name==="22철거"?-60:SUNGSU_TILESET_ADJUST_HEIGHT,
          splitDirection: Cesium.SplitDirection.RIGHT,
        },
      ]);
      setPhase(selectedItem.phase);
      setMoveActive(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  const setFolder = (tf: boolean) => {
    setCommonData({ ...commonData, folder: tf });
  }


  const moveToSpaceMode = (idx:string) => {
    setCommonData({ ...commonData, isActive: "Space mode", openIndex: idx });
   
  }



  return (
    <>
      {commonData.isActive === "Timeline mode" && (
        <Box
          sx={{
            zIndex: 999,
            height: '188px',
            width: commonData.folder ? '100%' : 'calc(100% - 265px)',
            marginLeft: commonData.folder ? '0px' : '264px',
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            position: 'absolute',
            borderLeft: commonData.folder ? '' : '1px solid #747474'
          }}
        >
          {commonData.folder ? (
            <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
              <ButtonBase
                sx={hamburgerIconStyle}
                onClick={() => {
                  setFolder(false);
                }}
              >
                <MenuIcon sx={{ color: "white" }} />
              </ButtonBase>
              <Typography
                key='timeline'
                sx={{
                  fontFamily: "Arimo",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "20px",
                  lineHeight: "22px",
                  letterSpacing: "-0.43px",
                  color: "#FFFFFF",
                  paddingLeft: '10px'
                }}
              >
                Timeline mode 
              </Typography>
            </Box>
          ) : (
            <Typography
              key='timeline'
              sx={{
                fontFamily: "Arimo",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "20px",
                lineHeight: "22px",
                letterSpacing: "-0.43px",
                color: "#FFFFFF",
                paddingLeft: '10px',
                paddingTop: '12px',
                height:'40px'
              }}
            >
              Timeline mode 
            </Typography>
          )}

          {commonData.project==="Banpo jugong Apt."?  <>
          <Box sx={{ display: 'flex', padding: '0 5%' }}>
            <Typography
              key='timeline1'
              sx={{ 
                ...timelineFontStyle, 
                marginRight: '10%',
                marginLeft:'3%',
                color: selectedItem?.name === "남서울 아파트" ? 'yellow' : 'white'
                
              }}
              onClick={() => {
               onClickEvent("남서울 아파트");
              }}
            >
              남서울 아파트/<br/>반포주공 아파트
              <br/>
              <YellowCircle/>
            </Typography>

            <Typography
              key='timeline3'
              sx={{ 
                ...timelineFontStyle, 
                marginRight: '20%',
                marginLeft:'0%',
                color: selectedItem?.name === "반포주공아파트 철거" ? 'yellow' : 'white'
                
              }}
              onClick={() => {
               onClickEvent("반포주공아파트 철거");
              }}
            >
              2022<br/>반포주공아파트 철거
              <br/>
              <YellowCircle/>
            </Typography>
            <Typography
              key='timeline4'
              sx={{ 
                ...timelineFontStyle, 
                marginRight: '5%' ,
                cursor: 'default',
              }}
              onClick={() => {
                onClickEvent("재건축 완료");
               }}
            >
              2030<br/>재건축 완료
              <br/>
              <YellowCircle/>
            </Typography>
          </Box>
          <TimelineBar/>
          <Box sx={{ display: 'flex', padding: '0 5%' }}>
            <Typography
              key='timeline2-1'
              sx={{ 
                ...timelineFontStyle2, 
                marginRight: '1%',
                marginLeft:'-6%',
                color: selectedItem?.name === "남서울 아파트" ? '#7ed87e' : 'white'

              }}
            
            >
       <WhiteCircle/>
                <br/>1979<br/>남서울 아파트 완공
            </Typography>

            <Typography
              key='timeline2-4'
              sx={{ 
                ...timelineFontStyle2, 
                marginLeft: '10%' ,
                color: selectedItem?.name === "반포주공아파트 철거" || selectedItem?.name === "남서울 아파트" ? '#7ed87e' : 'white'
              }}
              onClick={() => {
                moveToSpaceMode("반포 주공아파트 1차");
              }}
            >
                <WhiteCircle/>
                <br/>2022<br/>반포주공아파트 1차
            </Typography>
            <Typography
              key='timeline2-5'
              sx={{ 
                ...timelineFontStyle2, 
                marginRight: '10%',
                 color: selectedItem?.name === "반포주공아파트 철거" || selectedItem?.name === "재건축 완료" ? '#7ed87e' : 'white'
              }}
              onClick={() => {
                moveToSpaceMode("반포 주공아파트 2차");
              }}
            >
                <WhiteCircle/>
                <br/>2024.10<br/>반포주공아파트 2차
            </Typography>
            <Typography
              key='timeline2-6'
              sx={{ 
                ...timelineFontStyle2, 
                marginRight: '0%',
                cursor: 'default',
                 color: selectedItem?.name === "재건축 완료" ? '#7ed87e' : 'white'
              }}
              // onClick={() => {
              //   moveToSpaceMode("");
              // }}
            >
                <WhiteCircle/>
                <br/>2024.10<br/>반포 덮개공원 당선작 메뉴얼 모델링
            </Typography>
          </Box>
          </>
          : null}

          {commonData.project==="Bucheon Factory134"?   <>
          <Box sx={{ display: 'flex', padding: '0 5%' }}>
           
            <Typography
              key='timeline4'
              sx={{ 
                ...timelineFontStyle, 
                marginRight: '20%',
                marginLeft:'7%',
                color: selectedItem?.name === "22철거" ? 'yellow' : 'white'
                
              }}
              onClick={() => {
               onClickEvent("22철거");
              }}
            >
              2022<br/>철거
              <br/>
              <YellowCircle/>
            </Typography>
          </Box>
          <TimelineBar/>
          <Box sx={{ display: 'flex', padding: '0 5%' }}>
    
            <Typography
              key='timeline2-4'
              sx={{ 
                ...timelineFontStyle2, 
                marginRight: '0%' ,
                color: selectedItem?.name === "삼양비지네스폼 철거" ? '#7ed87e' : 'white'
              }}
              onClick={() => {
                moveToSpaceMode("성수클러스터_2차");
              }}
            >
                <WhiteCircle/>
                <br/>2022.08<br/>Bucheon Factory134 1차
            </Typography>
            <Typography
              key='timeline2-6'
              sx={{ 
                ...timelineFontStyle2, 
                marginRight: '0%',
                cursor: 'default',
              }}
              // onClick={() => {
              //   moveToSpaceMode("");
              // }}
            >
                <WhiteCircle/>
                <br/>2024.10<br/>현재
            </Typography>
          </Box>
          </>
          : null} 

          {commonData.project==="Paju Saemal Village"?   <>
          <Box sx={{ display: 'flex', padding: '0 5%' }}>

           

            <Typography
              key='timeline1'
              sx={{ 
                ...timelineFontStyle, 
                marginRight: '20%',
                marginLeft:'7%',
                color: selectedItem?.name === "철거" ? 'yellow' : 'white'
                
              }}
              onClick={() => {
               onClickEvent("철거");
              }}
            >
              2023<br/>철거
              <br/>
              <YellowCircle/>
            </Typography>
   
          </Box>
          <TimelineBar/>
          <Box sx={{ display: 'flex', padding: '0 5%' }}>
        
            <Typography
              key='timeline2-4'
              sx={{ 
                ...timelineFontStyle2, 
                marginRight: '0%' ,
                color: selectedItem?.name === "삼양비지네스폼 철거" ? '#7ed87e' : 'white'
              }}
              onClick={() => {
                moveToSpaceMode("Paju Saemal Village 1차");
              }}
            >
                <WhiteCircle/>
                <br/>2022.12<br/>Paju Saemal Village 1차
            </Typography>
            
            <Typography
              key='timeline2-6'
              sx={{ 
                ...timelineFontStyle2, 
                marginRight: '0%',
                cursor: 'default',
              }}
              // onClick={() => {
              //   moveToSpaceMode("");
              // }}
            >
                <WhiteCircle/>
                <br/>2024.10<br/>현재
            </Typography>
          </Box>
          </> : null}
         
        </Box>
      )}
    </>
  )
}

export default Timeline;